export default {
  common: {
    done: 'Fertig',
    term: 'Laufzeit',
    year: 'Jahr | Jahre',
    years: 'Jahre',
    yr: '/Jahr',
    month: 'Monat | Monate',
    quantity: 'Quantität',
    add: 'Hinzufügen',
    loading: 'Lädt...',
    error: "Bitte korrigieren Sie die Fehler oder <a  class='link-info'>entfernen</a> Sie das Element aus Ihrem Warenkorb.",
    domain: 'Domain',
    edit: 'Bearbeiten',
    account: 'Konto',
    accounts: 'Konten',
    zone: 'Zone',
    zones: 'Zonen',
    relay: 'Relais',
    relays: 'Relais',
    enter_domain: 'Domain eingeben',
    hostnames: 'Hostnames',
    term_callout: 'Benötigen Sie eine längere Laufzeit?',
    select_term: 'Wählen Sie Ihren Begriff aus',
    recommended: 'Empfohlen',
    save: 'Salva',
    includes: 'Inklusive',
    adjusting_preview: 'Vorschau anpassen',
    coupon_code_is_not_valid: 'Der Gutscheincode ist ungültig.',
    contact_support_if_you_believe_this_is_an_error: 'Wenden Sie sich an den Support, wenn Sie glauben, dass es sich hierbei um einen Fehler handelt.',
    coupon_applied: 'Gutschein angewendet',
    sub_total: 'Zwischensumme',
    available_credit: 'Verfügbarer Kredit',
    credit_used: 'Guthaben verwendet',
    coupon_code_will_be_applied_once_logged_in: 'Der Gutscheincode wird nach der Anmeldung angewendet.',
    monthly: 'Monatlich',
    annually: 'Jährlich'
  },
  topnav: {
    planbuilder: 'Plan-Ersteller',
    payment: 'Zahlung',
    orderconfirmation: 'Bestellbestätigung'
  },
  plan_builder: {
    undo: 'Rückgängig machen',
    item_removed: 'Ein Service wurde aus Ihrem Warenkorb entfernt.',
    select_term: '<span class="text-semibold">Laufzeit</span> für Ihr Abonnement auswählen',
    years: 'Jahre',
    apply: 'Anwenden',
    total: 'Gesamt',
    proceed_to_checkout: 'Zur Kasse gehen',
    removed_items: 'Der/Die folgende(n) Service(s) wurden von Ihrem Warenkorb entfernt, weil Sie bereits ein aktives Abonnement für diese(s) Produkt(e) haben:',
    billing_management: 'Bitte besuchen Sie die <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Rechnungsmanagement</a>-Seite, wenn Sie diese erneuern möchten.',
    open_invoice: 'Sie haben eine offene Rechnung für den/die Service(s), die sich bereits in Ihrem Warenkorb befinden, die entfernt wurden.',
    invoice_link: 'Bitte gehen Sie zu <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Rechnungsmanagement</a> und zahlen Sie diese Rechnungen, um Ihre(n) Service(s) fortzusetzen.',
    empty_cart: 'Ihr Warenkorb ist leer',
    purchase_services: 'Sehen Sie sich alle Services an, die Sie auf <a href="/" class="text-info text-decoration-none">No-IP</a> kaufen können',
    updated_enhanced_item: 'Sie haben derzeit <span class="text-semibold">{hostcount} Hostnamen</span> und diese überschreiten <span class="text-semibold">{itemtitle} {itemoptionsquantity} Hostname(s)</span>. Wir haben Ihren Einkaufswagen aktualisiert, um zum nächsten verfügbaren Abonnement zu wechseln, <span class="text-semibold">{newitemtitle} {newitemoptionsquantity} Hostnamen</span>.'
  },
  account: {
    create_an_account: 'Ein Konto erstellen',
    have_an_account: 'Haben Sie ein Konto?',
    create_account: 'Konto erstellen',
    log_in: 'Anmelden',
    email: 'E-Mail',
    user_password: 'Passwort',
    tos: "Ich stimme den <a href='/legal/tos'>Allgemeinen Geschäftsbedingungen</a> und der <a href='/legal/privacy'>Datenschutzerklärung</a> zu.",
    newsletter: 'Senden Sie mir den Newsletter und Spezialangebote',
    log_in: 'Anmelden',
    email_username: 'E-Mail oder Benutzername',
    forgotpassword: 'Passwort vergessen?',
    login_continue: 'Anmelden und fortfahren',
    auth_failure: 'Kombination aus Benutzername/Passwort ist falsch. Bitte erneut versuchen.',
    too_many_attempts: 'Ihre IP-Adresse wurde über dieses Formular zu viele Male eingereicht. Bitte warten Sie ein paar Minuten, bevor Sie es erneut versuchen.',
    too_many_attempts: 'Ihr Konto wurde aufgrund von zu vielen Fehlern bei der Passworteingabe gesperrt. Das Konto wird in 15 Minuten entsperrt, dann können Sie sich erneut anmelden. Sie können auch die Nummer 1-877-367-6647 während der Bürozeiten anrufen: 6:30 - 17:30 Uhr Pacific Time, Montag-Freitag, um Ihr Konto sofort freizuschalten. Dies ist eine Sicherheitsfunktion, um Brute-Force-Anmeldeversuche zu verhindern. Wenn Sie Ihr Passwort vergessen haben, verwenden Sie unser Formular "Passwort vergessen", um sich einen Link zum Zurücksetzen des Passworts zusenden zu lassen. Versuchen Sie dann, sich in 15 Minuten erneut anzumelden.',
    captcha_failure: 'reCAPTCHA fehlgeschlagen. Sie müssen reCAPTCHA erfolgreich abschließen, bevor Sie sich anmelden.',
    newsletter: 'Senden Sie mir Newsletter & Sonderangebote',
    create_account: 'Benutzerkonto erstellen',
    logged_in_as: 'Angemeldet als',
    create_an_account: 'Müssen Sie ein Konto erstellen?',
    already_have_an_account: 'Sie haben bereits ein Konto?',
    sign_up_with_google: 'Mit Google anmelden',
    sign_in_with_google: 'Mit Google einloggen',
    sign_up_with_microsoft: 'Mit Microsoft anmelden',
    sign_in_with_microsoft: 'Mit Microsoft einloggen'
  },
  domain_input: {
    tooltip: 'Geben Sie die Domain ein, die Sie mit diesem Service verwenden möchten. Hinweis: Das wird die Domain nicht registrieren.'
  },
  domain_reg: {
    tooltip: 'Registrieren Sie Ihre Domain mit No-IP, eine von ICANN zugelassene Registrierungsstelle.'
  },
  account_enhanced: {
    tooltip: 'Remote-Access auf einen Computer, ein Gerät oder ein Netzwerk, ohne sich über monatliche Hostnamen-Bestätigungen sorgen zu müssen.',
    hostnames: 'Hostnamen'
  },
  support_priority: {
    tooltip: 'Ein Support-Kanal mit Priorität, der mit unserem freundlichen und erfahrenen technischen Support-Team besetzt ist. Ihr Ticket oder Ihre Supportanfrage wird an die erste Stelle der Warteschlange gestellt, damit Sie Hilfe bekommen, wenn Sie sie am dringendsten benötigen.'
  },
  dns_tier: {
    tooltip: 'Schnelles und zuverlässiges DNS für Ihre Domain, unterstützt durch unser robustes Anycast-Netzwerk mit mehr als 100 Präsenzpunkten auf der ganzen Welt.'
  },
  dns_squared: {
    tooltip: 'Maximieren Sie die Uptime und erhöhen Sie die Zuverlässigkeit unter Verwendung Ihrer bestehenden DNS-Infrastruktur.'
  },
  mail_backupmx: {
    tooltip: 'Mit Backup MX können Sie beruhigt sein. Wenn Ihr Mailserver ausfällt, gehen Ihnen keine wichtigen E-Mails verloren.'
  },
  mail_reflector: {
    tooltip: 'Betreiben Sie Ihren eigenen Mailserver, auch wenn Ihr ISP Port 25 blockiert'
  },
  mail_pop: {
    tooltip: 'POP3/IMAP ist die ideale Option für alle, die sich nicht mit der Verwaltung eines eigenen E-Mail-Servers herumschlagen wollen.'
  },
  mail_forwarding: {
    tooltip: 'Mit E-Mail-Weiterleitung können Sie E-Mails für Ihre Domain empfangen und an ein bestehendes Konto weiterleiten lassen.'
  },
  mail_smtp: {
    tooltip: 'SMTP eignet sich für Administratoren, die einen blockierten Port 25 haben, oder für Außendienstmitarbeiter, die die SMTP-Einstellungen nicht ändern möchten.'
  },
  ssl_rapid: {
    tooltip: 'Sichert eine einzelne Domain mit starker Verschlüsselung. Sie wird innerhalb von Minuten ausgestellt und hilft Ihnen, schnell eine sichere Website zu entwickeln und zu starten.'
  },
  ssl_rapid_dv: {
    tooltip: 'Sichert eine einzelne Domain mit starker Verschlüsselung. Sie wird innerhalb von Minuten ausgestellt und hilft Ihnen, schnell eine sichere Website zu entwickeln und zu starten.'
  },
  ssl_premium: {
    tooltip: 'Bietet umfassende Authentifizierungsverfahren (Domainnamen und Identitätsverifizierung) mit einer hohen Garantie, wodurch dieses Zertifikat perfekt zur Absicherung Ihrer professionellen Domain ist.'
  },
  ssl_rapid_wildcard: {
    tooltip: 'Sichern Sie unbegrenzte Subdomains mit starker Verschlüsselung. Zertifikate werden innerhalb von Minuten ausgestellt und sind die kostengünstigste Möglichkeit, mehrere Domains zu sichern.'
  },
  ssl_rapid_wildcard_dv: {
    tooltip: 'Sichern Sie unbegrenzte Subdomains mit starker Verschlüsselung. Zertifikate werden innerhalb von Minuten ausgestellt und sind die kostengünstigste Möglichkeit, mehrere Domains zu sichern.'
  },
  ssl_trustcor_standard: {
    tooltip: 'Sichert einen einzelnen Hostnamen mit starker Verschlüsselung. Er wird innerhalb von Minuten ausgestellt und hilft Ihnen, schnell eine sichere Website zu entwickeln und zu starten.'
  },
  ssl_trustcor_premium: {
    tooltip: 'Sichert einen einzelnen Hostnamen mit starker Verschlüsselung. Er wird innerhalb von Minuten ausgestellt und hilft Ihnen, schnell eine sichere Website zu entwickeln und zu starten.'
  },
  ssl_trustcor_wildcard: {
    tooltip: 'Sichern Sie unbegrenzte Subdomains mit starker Verschlüsselung. Zertifikate werden innerhalb von Minuten ausgestellt und sind die kostengünstigste Möglichkeit, mehrere Domains zu sichern.'
  },
  monitor_basic: {
    tooltip: 'Der Ausfall eines Servers ist eine Sache, davon nichts zu wissen ist noch schlimmer. Lassen Sie sich sofort benachrichtigen, wenn es ein Problem gibt.'
  },
  monitor_advanced: {
    tooltip: 'Serverüberwachung rund um die Uhr, einschließlich automatischer Ausfallsicherung. Lassen Sie Ihre DNS-Einstellungen automatisch auf Ihren Backup-Server oder eine benutzerdefinierte Seite verweisen.'
  },
  team_login: {
    tooltip: 'Team Login ermöglicht Ihnen eine nahtlose Koordination mit verschiedenen Logins, die mit Ihrem Konto verknüpft sind.'
  },
  registration_domain: {
    tooltip: 'Registrieren Sie Ihre Domain mit No-IP, eine von ICANN zugelassene Registrierungsstelle.',
    bundle_discount: 'Paket-Rabatt',
    you_saved: 'Sie haben gespart',
    hide_info: 'Ja, meine persönlichen Informationen vor der Welt zu verbergen für',
    no_thanks: 'Nein, danke',
    private_registration_no: 'Private Registrierung - Nein'
  },
  registration_transfer: {
    tooltip: 'Übertragen Sie Ihre Domain von einer anderen Registrierungsstelle zu No-IP.'
  },
  registration_privacy: {
    tooltip: 'Bei der privaten Registrierung bleiben die Kontaktinformationen Ihrer Domain privat. Wir richten einen Proxy ein, der sich um den Spam kümmert und Ihnen das weiterleitet, was Sie brauchen.',
    private_registration: 'Private Registrierung'
  },
  host_redemption: {
    tooltip: 'Stellen Sie Ihren Hostnamen aus Redemption wieder her und behalten Sie die gleiche Konfiguration bei, die Sie vor Redemption hatten.'
  },
  dns_pro: {
    tooltip: 'Erstellen Sie Hostnamen auf Ihrer eigenen Domain oder verwenden Sie eine No-IP-eigene Domain mit professionellem dynamischem DNS, das sich Ihren Anforderungen anpasst.'
  },
  domain_contact: {
    contact: {
      oganization: 'Organisation',
      email_address: 'E-Mail Adresse',
      first_name: 'Eigenname',
      last_name: 'Nachname',
      address: 'Adresse',
      address2: 'Adresse 2',
      country: 'Land',
      state_province: 'Bundesland / Provinz',
      city: 'Stadt',
      postal_zip: 'Postleitzahl',
      phone_number: 'Telefonnummer'
    },
    contact_form: {
      domain_contact: 'Domain-Kontakt',
      domain_contact_text: 'Die Domain-Registrierung erfordert gültige Domain-Kontaktinformationen, um registriert zu werden. Das bedeutet, dass Ihr persönlicher Name und Ihre Kontaktdaten im WHOIS-Register öffentlich zugänglich sind. Falls Sie eine Private Registrierung hinzugefügt haben, werden im Datensatz unsere Informationen anstelle Ihrer angezeigt. Machen Sie sich keine Sorgen, etwas verpassen, wir leiten alle wichtigen Informationen an Sie weiter.',
      add_private_reg: 'Private Registrierung jetzt hinzufügen',
      existing_domain_contact: 'Einen bestehenden Domain-Kontakt verwenden',
      new_domain_conact: 'Einen neuen Domain-Kontakt erstellen',
      verifying: 'Prüfen',
      continue: 'Weiter',
      an_unexpected_error: "Leider ist ein unerwarteter Fehler aufgetreten. Versuchen Sie es bitte in einigen Minuten erneut. Falls dieser Fehler weiterhin auftritt, melden Sie ihn bitte in einem <a href='/ticket'>Support-Ticket</a> mit Ihren Kontaktdaten."
    },
    order_summary: {
      order_summary: 'Bestellübersicht',
      edit: 'Bearbeiten'
    }
  },
  upsell: {
    add_to_cart: 'in den Warenkorb legen',
    plus_description: 'Vollständig angepasstes dynamisches DNS durch Erstellen eines leicht zu merkenden Hostnamens auf Ihrer eigenen Domain.',
    enhanced_description: 'Erstellen Sie einen leicht zu merkenden Hostnamen, um remote auf Ihr Gerät zuzugreifen, und machen Sie sich keine Gedanken über die Bestätigung Ihres Hostnamens, solange Ihr Abonnement aktiv bleibt.',
    priority_description: 'No-IP Priority Support ist ein vorrangiger Support-Kanal, der mit unserem freundlichen und erfahrenen technischen Support-Team besetzt ist. Priority Support ermöglicht es Ihnen, die benötigte Unterstützung so schnell wie möglich zu erhalten.',
    rapid_description: 'RapidSSL Basic DV-Zertifikate sichern eine einzelne Domain mit starker Verschlüsselung. Es wird innerhalb von Minuten ausgestellt und hilft Ihnen, schnell eine sichere Website zu entwickeln und zu starten. Es ist eine schnelle und kostengünstige Möglichkeit, Ihre Website zu sichern.',
    rapid_wildcard_description: 'RapidSSL-Wildcard-Zertifikate sichern unbegrenzte Subdomains mit starker Verschlüsselung. Zertifikate werden innerhalb von Minuten ausgestellt und sind die kostengünstigste Möglichkeit, mehrere Domains zu sichern.',
    team_login_description: 'Mit der Team-Anmeldung können Sie weitere Teammitglieder zu Ihrem Konto einladen. Lassen Sie sich von Ihren Teammitgliedern dabei unterstützen, mehr bei der Verwaltung von Kunden, Abonnements und mehr zu erledigen.',
    recommended: 'Empfohlen',
    team_login_tooltip: 'Für jedes No-IP-Konto gibt es einen Kontoinhaber. Benötigen Sie ein weiteres Login? Fügen Sie ein Teammitglied zu Ihrem Konto hinzu.',
    per_team_member: 'pro Teammitglied'
  }
};
